import { useReducer as o, useState as f, useEffect as a, useCallback as l } from "react";
function m(n, t) {
  return [
    `(min-width: ${n}px)`,
    t ? `and (max-width: ${t - 0.02}px)` : ""
  ].join(" ");
}
function s(n) {
  return typeof window < "u" ? window.matchMedia(n) : null;
}
function h(n, t) {
  return n ? n.media === t ? n : s(t) : null;
}
function L(n, t) {
  const r = m(n, t), [e, u] = o(h, r, s), d = f(0)[1];
  a(() => {
    u(r);
  }, [r, u]);
  const i = l(() => {
    d((c) => c + 1);
  }, [d]);
  return a(() => (e && (e.addListener ? e.addListener(i) : e.addEventListener("change", i)), () => {
    e && (e.removeListener ? e.removeListener(i) : e.removeEventListener("change", i));
  }), [e, i]), e ? e.matches : !1;
}
export {
  L as useMatchMedia
};
